"use client";

import * as PopoverPrimitive from "@radix-ui/react-popover";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { PopoverTriggerProps } from "../types";
import { usePopover } from "./popover-root";

function PopoverTrigger({ className, ...props }: PopoverTriggerProps) {
  const { getTriggerHoverProps } = usePopover();
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <PopoverPrimitive.Trigger
      data-slot="popover-trigger"
      className={cn("hover:cursor-pointer", className, classes)}
      {...native}
      {...getTriggerHoverProps()}
    />
  );
}

PopoverTrigger.displayName = "Popover.Trigger";

export default PopoverTrigger;
